<div class="dialog-wrapper">
  <h1 mat-dialog-title class="header">
    {{ dialogData.title }}
  </h1>
  <mat-dialog-content>
    <div class="pb-2">{{ dialogData.displayText }}</div>
    @if (!!dialogData.additionalDisplayText) {
    <div class="pb-2">{{ dialogData.additionalDisplayText }}</div>
    }
    <div class="pb-2 mr-2">
      @if (dialogData.isConfirmed) {
      <form [formGroup]="confirmationForm">
        <mat-form-field>
          <mat-label>{{ dialogData.inputPlaceholder }}</mat-label>
          <input matInput type="text" formControlName="comment">
          @if (hasErrorOfType('comment', 'required') || hasErrorOfType('comment', 'maxlength')
          || hasErrorOfType('comment', 'minlength')) {
          <mat-error>
            {{ dialogData.validationMessage }}
          </mat-error>
          }
        </mat-form-field>
      </form>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="mb-0" align="end">
    @if (dialogData.isConfirmed) {
    <button mat-raised-button type="button" color="primary" mat-dialog-close>{{dialogData.cancelBtnName ?
      dialogData.cancelBtnName : 'Cancel' }}</button>
    <button mat-raised-button color="primary" [disabled]="confirmationForm.invalid"
      [mat-dialog-close]="confirmationForm.invalid ? '' : commentCtrl.value">
      {{ dialogData.confirmBtnName ? dialogData.confirmBtnName : 'Confirm' }}</button>
    } @else {
    <button mat-raised-button type="button" color="primary" mat-dialog-close>No</button>
    <button mat-raised-button cdkFocusInitial color="primary" (click)="onConfirm()">Yes</button>
    }
  </mat-dialog-actions>
</div>